import { useUpdatePersonal as useUpdatePersonalLib } from '@ppay/client'

import { User } from '../../../interfaces'

export const useUpdatePersonal = () => useUpdatePersonalLib<User['personal']>()
